import React from 'react';
import ContentLoader from 'react-content-loader';
import { Col } from 'reactstrap';
import './TimeSelector.scss';

const TimeSelectorLoader = () => {
  return (
    <Col className="time-selector-loader" xs="12" sm="12" md="12">
      <ContentLoader height={90}>
        <rect className="placeholder-rect-1" />
        <rect className="placeholder-rect-2" />
      </ContentLoader>
    </Col>
  );
};

export default TimeSelectorLoader;



// WEBPACK FOOTER //
// ./src/components/molecules/TimeSelector/TimeSelectorLoader.js